import {
  ErrorDefault,
  RequestDefault,
  ResponseDefault,
} from "../../shared/constant";
import paymentConstants from "../constants/paymentConstants";

const initialState: {
  payments: any[];
  paymentsResponse: any;
  paymentDetails: any;
  error: Boolean;
  pending: Boolean;
  fulfilled: Boolean;
  createPaymentSuccess: Boolean;
  updatePaymentSuccess: Boolean;
  paymentsPending: Boolean;
} = {
  payments: [],
  paymentsResponse: null,
  paymentDetails: null,
  error: false,
  pending: false,
  fulfilled: false,
  createPaymentSuccess: false,
  updatePaymentSuccess: false,
  paymentsPending: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case paymentConstants.GET_PAYMENTS_REQUEST:
      return {
        ...state,
        paymentsPending: true,
      };
    case paymentConstants.GET_PAYMENTS_SUCCESS:
      return {
        ...state,
        paymentsPending: false,
        payments: action.payload.data.results,
        paymentsResponse: action.payload.data,
      };
    case paymentConstants.GET_PAYMENTS_FAILURE:
      return {
        ...state,
        paymentsPending: false,
      };
    case paymentConstants.GET_PAYMENT_DETAILS_SUCCESS:
      return {
        ...state,
        paymentDetails: action.payload.data,
      };
    case paymentConstants.CREATE_PAYMENT_REQUEST:
      return {
        ...state,
        ...RequestDefault,
      };
    case paymentConstants.CREATE_PAYMENT_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
        createPaymentSuccess: true,
      };
    case paymentConstants.CREATE_PAYMENT_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
      };
    case paymentConstants.UPDATE_PAYMENT_SUCCESS:
      return {
        ...state,
        updatePaymentSuccess: true,
      };

    case paymentConstants.RESET_PAYMENTS:
      return {
        ...state,
        payments: [],
        paymentsResponse: null,
        createPaymentSuccess: false,
        paymentDetails: null,
        updatePaymentSuccess: false,
      };
    default:
      return {
        ...state,
      };
  }
};
